import React, { useState, useEffect, useRef } from "react";
import "../../../Content/Styles/PokerWidget.less";
import RiveComponent from "../Shared/RiveComponent";

import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';

export const PokerWidget = (props) => {
    // Stats references, HizmanB
    const [liveInfo, setLiveInfo] = useState(null);
    const dataPromisesRef = useRef(null);
    const dataIntervalRef = useRef(null);

    // Slider reference, HizmanB
    const carouselRef = useRef(null);
    const flickityInstance = useRef(null);

    // Render podaci, HizmanB
    const playButtonName = `Zaigraj poker`;
    const findMoreButtonName = `Saznaj više`;
    const fullTurnirUrl = `${casino.config.urls.mobile}poker/tournaments/`;
    const serverUrl = 'https://cdn.supersport.hr';

    // Provjera i mappiranje vremena eventa, HizmanB
    const getDynamicTime = (schedule) => {
        if (!schedule || schedule.length === 0) return "USKORO";

        const totalDays = new Set(schedule.map(slot => slot.day.toLowerCase()));

        if (totalDays.size === 7) {
            const hasTime = schedule.some(slot => slot.from && slot.to);
            const uniqueTimes = new Set(schedule.map(slot => `${slot.from}-${slot.to}`));

            if (!hasTime) {
                return "SVAKI DAN";
            } else if (uniqueTimes.size === 1) {
                const firstSlot = schedule[0];
                const showTo = firstSlot.to && firstSlot.from !== firstSlot.to;

                return `SVAKI DAN od ${firstSlot.from}${showTo ? ` do ${firstSlot.to}` : ''}`;
            }
        }

        const dayMap = { ned: 0, pon: 1, uto: 2, sri: 3, čet: 4, cet: 4, pet: 5, sub: 6 };
        const dayNamesInstrumental = {
            0: "NEDJELJOM", 1: "PONEDJELJKOM", 2: "UTORKOM", 3: "SRIJEDOM",
            4: "ČETVRTKOM", 5: "PETKOM", 6: "SUBOTOM"
        };

        const now = new Date();
        const currentDayIndex = now.getDay();

        let closestMatch = null;
        let minDiffInMinutes = Infinity;

        schedule.forEach(slot => {
            let dayStr = slot.day.toLowerCase();
            if (dayStr === 'cet') dayStr = 'čet';

            const targetDayIndex = dayMap[dayStr];
            if (targetDayIndex === undefined) return;

            let daysDiff = targetDayIndex - currentDayIndex;
            if (daysDiff < 0) daysDiff += 7;

            let hours = 0, minutes = 0;
            if (slot.from) {
                [hours, minutes] = slot.from.split(':').map(Number);
            }

            const targetDate = new Date(now);
            targetDate.setDate(now.getDate() + daysDiff);
            targetDate.setHours(hours, minutes, 0, 0);

            if (daysDiff === 0 && slot.from && targetDate.getTime() <= now.getTime()) {
                targetDate.setDate(targetDate.getDate() + 7);
                daysDiff = 7;
            }

            const timeDiff = targetDate.getTime() - now.getTime();

            if (timeDiff < minDiffInMinutes) {
                minDiffInMinutes = timeDiff;
                closestMatch = {
                    daysDiff: daysDiff,
                    from: slot.from,
                    to: slot.to,
                    targetDayIndex: targetDayIndex
                };
            }
        });

        if (!closestMatch) return "USKORO";

        let dayPrefix = "";
        if (closestMatch.daysDiff === 0 || closestMatch.daysDiff === 7) {
            dayPrefix = "DANAS";
        } else if (closestMatch.daysDiff === 1) {
            dayPrefix = "SUTRA";
        } else if (closestMatch.daysDiff === 2) {
            dayPrefix = "PREKOSUTRA";
        } else {
            dayPrefix = dayNamesInstrumental[closestMatch.targetDayIndex];
        }

        if (!closestMatch.from) {
            return dayPrefix;
        }

        const timeString = closestMatch.from === closestMatch.to
            ? `od ${closestMatch.from}`
            : `od ${closestMatch.from}${closestMatch.to ? ` do ${closestMatch.to}` : ''}`;

        return `${dayPrefix} ${timeString}`;
    };

    // Podaci, HizmanB
    const tableData = [
        {
            id: 1,
            sifra: "Spin2Win",
            time: [
                { day: "pon" },
                { day: "uto" },
                { day: "sri" },
                { day: "čet" },
                { day: "pet" },
                { day: "sub" },
                { day: "ned" }
            ],
            text: "Za igrače koji vole kratke poker turnire, bez dugog čekanja i kompleksnih struktura turnira."
        },
        {
            id: 2,
            sifra: "Bankroll-Booster",
            time: [
                { day: "pon", from: "12:00", to: "12:00" },
                { day: "uto", from: "12:00", to: "12:00" },
                { day: "sri", from: "12:00", to: "12:00" },
                { day: "čet", from: "12:00", to: "12:00" },
                { day: "pet", from: "12:00", to: "12:00" },
                { day: "sub", from: "12:00", to: "12:00" },
                { day: "ned", from: "12:00", to: "12:00" }
            ],
            text: "Nekoliko Freeroll Bankroll Booster Poker turnira mjesečno uz uvjete za besplatan ulaz."
        },
        {
            id: 3,
            sifra: "Deepstack-Classic",
            time: [
                { day: "pon", from: "20:00", to: "20:00" },
                { day: "uto", from: "20:00", to: "20:00" },
                { day: "sri", from: "20:00", to: "20:00" },
                { day: "čet", from: "20:00", to: "20:00" },
                { day: "pet", from: "20:00", to: "20:00" },
                { day: "sub", from: "20:00", to: "20:00" },
                { day: "ned", from: "20:00", to: "20:00" }
            ],
            text: "Turnir s garantiranim iznosom nagrada, bez obzira na broj sudionika."
        },
        {
            id: 4,
            sifra: "Freeroll",
            time: [
                { day: "pon", from: "18:00", to: "18:00" },
                { day: "uto", from: "18:00", to: "18:00" },
                { day: "sri", from: "18:00", to: "18:00" },
                { day: "čet", from: "18:00", to: "18:00" },
                { day: "pet", from: "18:00", to: "18:00" },
                { day: "sub", from: "18:00", to: "18:00" },
                { day: "ned", from: "18:00", to: "18:00" }
            ],
            text: "Ovi turniri imaju besplatan ulaz i garantirani iznos nagrada. Turbo struktura i brzo se dolazi do pobjednika!"
        },
        {
            id: 5,
            sifra: "Freezeout",
            time: [
                { day: "pon", from: "20:00", to: "20:00" },
                { day: "uto", from: "20:00", to: "20:00" },
                { day: "sri", from: "20:00", to: "20:00" },
                { day: "čet", from: "20:00", to: "20:00" },
                { day: "pet", from: "20:00", to: "20:00" },
                { day: "sub", from: "20:00", to: "20:00" },
                { day: "ned", from: "20:00", to: "20:00" }
            ],
            text: "Za razliku od Rebuy turnira imate samo jedan pokušaj da svoje početne chipove pretvorite u novčane nagrade!"
        },
        {
            id: 6,
            sifra: "Nedjeljni-Classic",
            time: [
                { day: "ned", from: "19:00", to: "19:00" }
            ],
            text: "Najpopularniji i najveći tjedni online Poker turnir koji se održava svake nedjelje."
        },
        {
            id: 7,
            sifra: "Turbo",
            time: [
                { day: "pon", from: "21:00", to: "21:00" },
                { day: "uto", from: "21:00", to: "21:00" },
                { day: "sri", from: "21:00", to: "21:00" },
                { day: "čet", from: "21:00", to: "21:00" },
                { day: "pet", from: "21:00", to: "21:00" },
                { day: "sub", from: "21:00", to: "21:00" },
                { day: "ned", from: "21:00", to: "21:00" }
            ],
            text: "Za igrače koji ne preferiraju dugačke turnire, igra je puna adrenalina i lako je doći do nagrada!"
        },
        {
            id: 8,
            sifra: "Bubalica",
            time: [
                { day: "pon", from: "23:00", to: "23:00" },
                { day: "uto", from: "23:00", to: "23:00" },
                { day: "sri", from: "23:00", to: "23:00" },
                { day: "čet", from: "23:00", to: "23:00" },
                { day: "pet", from: "23:00", to: "23:00" },
                { day: "sub", from: "23:00", to: "23:00" },
                { day: "ned", from: "23:00", to: "23:00" }
            ],
            text: "SuperSport Poker Bubalica je još jedan Rebuy turnir s neograničenim Addonovima!"
        },
        {
            id: 9,
            sifra: "Dnevni-Main-Event",
            time: [
                { day: "pon", from: "19:00", to: "19:00" },
                { day: "uto", from: "19:00", to: "19:00" },
                { day: "sri", from: "19:00", to: "19:00" },
                { day: "čet", from: "19:00", to: "19:00" },
                { day: "pet", from: "19:00", to: "19:00" },
                { day: "sub", from: "19:00", to: "19:00" },
                { day: "ned", from: "19:00", to: "19:00" }
            ],
            text: "Ovaj turnir donosi svakodnevnu priliku za dobar rezultat uz pristupačan buy-in i stabilne garantirane iznose."
        },
        {
            id: 10,
            sifra: "Mrcina",
            time: [
                { day: "sri", from: "19:00", to: "19:00" }
            ],
            text: "Turnir za one koji žele više. Veći ulog, jača konkurencija i ozbiljna igra od prve ruke."
        },
        {
            id: 11,
            sifra: "Kapitalac",
            time: [
                { day: "ned" }
            ],
            text: "Najveći garantirani nagradni fond na siteu i više prilika za veliki rezultat i ozbiljan profit."
        },
        {
            id: 12,
            sifra: "Sateliti",
            time: [
                { day: "pon", from: "17:00", to: "17:00" },
                { day: "uto", from: "17:00", to: "17:00" },
                { day: "sri", from: "17:00", to: "17:00" },
                { day: "čet", from: "17:00", to: "17:00" },
                { day: "pet", from: "17:00", to: "17:00" },
                { day: "sub", from: "17:00", to: "17:00" },
                { day: "ned", from: "17:00", to: "17:00" }
            ],
            text: "Kroz satelite možeš za mali buy-in osvojiti ulaz u Mrcinu ili Nedjeljni Classic."
        },
    ];

    useEffect(() => {
        if (carouselRef.current) {
            flickityInstance.current = new Flickity(carouselRef.current, {
                cellAlign: 'center',
                wrapAround: true,
                pageDots: false,
                prevNextButtons: false,
                draggable: true,
                contain: false,
                freeScroll: false,
                cellSelector: '.turniriElement'
            });
        }

        return () => {
            if (flickityInstance.current) {
                flickityInstance.current.destroy();
            }
        };
    }, []);

    // Dohvacanje podataka s API-ja i bindanje na elemente, HizmanB
    const fetchData = () => {
        const promises = Promise.all([casino.repos.pokerLiveInfoRepo.get()]);

        dataPromisesRef.current = casino.utils.makeCancelablePromise(promises);

        dataPromisesRef.current.promise
            .then((data) => {
                const [liveInfoData] = data;
                setLiveInfo(liveInfoData);
                dataIntervalRef.current = setTimeout(() => fetchData(), 30000);
            })
            .catch((reason) => {
                console.log('Dohvaćanje otkazano ili greška:', reason);
            });
    };

    useEffect(() => {
        //Stats setup, svakih 10 sekundi, HizmanB
        fetchData();
        return () => {
            if (dataPromisesRef.current?.cancel) {
                dataPromisesRef.current.cancel();
            }
            if (dataIntervalRef.current) {
                clearTimeout(dataIntervalRef.current);
            }
        };
    }, []);

    const appLink = () => {
        casino.repos.pokerUrlRepo.get().then((res) => {
            window.location.href = res.url;
        });
    };

    return (
        <div className="turniri">
            <div className="turniriComponent">
                <div className="turniriBackground" />
                <div className="turniriOverlay">
                    <div className="turniriTitle">{props.title}</div>
                    <div className="turniriStats">
                        <span className="turniriStatsText">Online korisnika:</span>
                        <span className="turniriStatsNumber broj-online-igraca">{liveInfo?.igraca || '0'}</span>
                        <span className="turniriStatsText">Cash stolova:</span>
                        <span className="turniriStatsNumber broj-cash-stolova">{liveInfo?.cashStolova || '0'}</span>
                        <span className="turniriStatsText">Aktivnih turnira:</span>
                        <span className="turniriStatsNumber">{tableData.length}</span>
                    </div>
                    <RiveComponent
                        className="turniriRive"
                        lazyLoad={true}
                        stateMachines= "State Machine 1"
                        artboard= "Artboard"
                        cacheBust={`c=${casino.config.guiCacheVerzija}`}
                        src={`${serverUrl}/Casino/Images/SuperPokerWidget/Web/SuperPoker_animation.riv`}
                        useOffscreenRenderer={true}
                        playRequest={true}
                        disablePlayOutsideViewport={{ rootMargin: "-50px 0px 0px 0px" }}
                    />
                    <button className="turniriZaigraj" onClick={appLink}>
                        <span className="turniriPlayIcon"></span>
                        <a className="turniriLinkAnchor" href="#/" onClick={(e) => e.preventDefault()}>
                            {playButtonName}
                        </a>
                    </button>
                </div>
                <div className="turniriBody">
                    <div className="turniriRightSlider">
                        <div className="turniriRightSliderContainer" ref={carouselRef}>
                            {tableData.map((element, index) => (
                                <div className="turniriElement" key={`${element.id}-${index}`}>
                                    <div className="turniriElementImage" />
                                    <div className="turniriElementTimeline">{getDynamicTime(element.time)}</div>
                                    <div className="turniriElementText">{element.text}</div>
                                    <button className="turniriElementSaznajVise">
                                        <a className="turniriElementLinkAnchor" href={`${fullTurnirUrl}${element.sifra}/info`}>{findMoreButtonName}</a>
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

};